'use strict';
/**
 * Normalize a raw avatar object: lower-case the communication type, voice and
 * mood (mirrors the original runner's `normalizedAssistant`).
 */
export function normalizeAvatar(raw) {
    var _a;
    if (!raw)
        return null;
    const a = Object.assign(Object.assign({}, raw), { communicationType: ((_a = raw.communicationType) !== null && _a !== void 0 ? _a : 'TEXT').toLowerCase(), voice: raw.voice ? String(raw.voice).toLowerCase() : null, mood: raw.mood ? String(raw.mood).toLowerCase() : null });
    return a;
}
